import crypto from 'crypto';

export const encodeAsSHA256 = (value: string) =>
    value ? crypto.createHash('sha256').update(value).digest('hex') : undefined;
